const simulation = (state) => state.simulation

const grossTotal = (state) => {
  const sim = state.simulation
  if (!sim) return 0
  return sim.totalValueWithoutDiscounts ?? sim.totalValue ?? 0
}

const offer = (state, getters) => {
  const sim = state.simulation
  if (!sim) return {}

  const catalogById = Object.values(state.assetsCatalog || {}).reduce(
    (acc, asset) => {
      acc[asset.id] = asset
      return acc
    },
    {}
  )

  const responseAssets = Array.isArray(sim.assets) ? sim.assets : []
  const enrichedAssets = responseAssets.map((responseAsset) => ({
    ...(catalogById[responseAsset.id] || {}),
    ...responseAsset,
  }))

  const persistedPanels = state.lastSimulatedPanels ?? state.specs.panels

  return {
    panels: persistedPanels,
    optimalPanels: persistedPanels,
    shadedPanels: 0,
    capex: sim.capex,
    installationValue: sim.installationValue,
    totalValueWithoutDiscounts: getters.grossTotal,
    assets: enrichedAssets,
    energyEfficiencyCertificatePriceWithTaxes:
      sim.energyEfficiencyCertificatePriceWithTaxes || undefined,
    energyEfficiencyCertificateQuantity:
      sim.energyEfficiencyCertificateQuantity,
    offerResizeInfo: null,
    grossMargin: sim.grossMargin ?? null,
    upPrice: sim.upPrice ?? null,
    upPriceWithTax: sim.upPriceWithTax ?? null,
    upPriceBreakdown: sim.upPriceBreakdown ?? null,
    canOffer: sim.canOffer !== false,
  }
}

// Lo que ve la UI es lo "aplicado" (último simulate exitoso), no lo que el
// usuario está tecleando. El descuento pendiente vive en specs.discounts y
// solo afecta a la UI cuando se pulsa "Aplicar descuentos".
const discounts = (state) => state.appliedDiscounts || {}

const hasDiscounts = (_state, getters) => {
  const d = getters.discounts
  return Object.values(d).some((value) => Number(value) > 0)
}

const totalValueWithDiscounts = (_state, getters) => {
  const gross = getters.grossTotal
  const offer = getters.offer
  const d = getters.discounts

  const hasBattery = (offer.assets || []).some((a) => a.type === 'battery')
  const hasEvCharger = (offer.assets || []).some((a) => a.type === 'evCharger')
  const hasCertificate = Boolean(
    offer.energyEfficiencyCertificatePriceWithTaxes
  )

  let total = gross
  total -= Number(d.panels) || 0
  if (hasBattery) total -= Number(d.battery) || 0
  if (hasEvCharger) total -= Number(d.evCharger) || 0
  if (hasCertificate) total -= Number(d.certificate) || 0
  return total
}

const listAssets = (state) => {
  const selectedAssets = state.specs.assets || []
  return Object.values(state.assetsCatalog || [])
    .slice()
    .sort((a, b) => (a.capacity ?? 0) - (b.capacity ?? 0))
    .reduce((acc, item) => {
      const selected = selectedAssets.find((asset) => asset.id === item.id)
      acc[item.id] = {
        ...item,
        id: item.id,
        amount: selected ? selected.amount : 0,
      }
      return acc
    }, {})
}

const hasPendingDiscount = (state) => {
  if (!state.simulation) return false
  const specs = state.specs?.discounts ?? {}
  const applied = state.appliedDiscounts ?? {}
  const keys = ['panels', 'battery', 'evCharger', 'certificate']
  return keys.some(
    (key) => Number(specs[key] ?? 0) !== Number(applied[key] ?? 0)
  )
}

export default {
  simulation,
  grossTotal,
  offer,
  discounts,
  hasDiscounts,
  totalValueWithDiscounts,
  listAssets,
  hasPendingDiscount,
}
